module.exports = __webpack_public_path__ + "img/75.1935779e.jpg";